class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;
  }

  onChange() {
    super.onChange();
    this.close();
  }

  onFormSubmit(event) {
    if (!this.input?.value.trim().length) event.preventDefault();
  }

  close() {
    this.removeAttribute('loading');
    this.removeAttribute('open');
    if (this.input) this.input.setAttribute('aria-expanded', 'false');
    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.innerHTML = '';
      this.predictiveSearchResults.removeAttribute('style');
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);
